var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLicencesIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 5.00008V7.01675C18.3333 8.33341 17.4999 9.16675 16.1832 9.16675H13.3333V3.34175C13.3333 2.41675 14.0916 1.66675 15.0166 1.66675C15.9249 1.67508 16.7583 2.04175 17.3583 2.64175C17.9583 3.25008 18.3333 4.08341 18.3333 5.00008Z",
    stroke: "#7E84A3",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66675 5.83341V17.5001C1.66675 18.1917 2.45006 18.5834 3.00006 18.1667L4.42508 17.1001C4.75841 16.8501 5.22509 16.8834 5.52509 17.1834L6.9084 18.5751C7.2334 18.9001 7.76677 18.9001 8.09177 18.5751L9.49176 17.1751C9.78343 16.8834 10.2501 16.8501 10.5751 17.1001L12.0001 18.1667C12.5501 18.5751 13.3334 18.1834 13.3334 17.5001V3.33341C13.3334 2.41675 14.0834 1.66675 15.0001 1.66675H5.83341H5.00008C2.50008 1.66675 1.66675 3.15841 1.66675 5.00008V5.83341Z",
    stroke: "#7E84A3",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 7.5H10",
    stroke: "#7E84A3",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 10.8333H9.375",
    stroke: "#7E84A3",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLicencesIcon);
export default __webpack_public_path__ + "static/media/licences-icon.2dc4c557f8549689909d5fbe0a5bf67c.svg";
export { ForwardRef as ReactComponent };